import api from '../../apiConfig/apiConfig';
import { Post, Get, Put, Patch, Delete } from '../base/baseAjax';

// 业务线下拉列表
let getserveList = function () {
	return Get({
		url: api.setmeal.serveList,
	});
};

let versionsAudit = function (param) {
	return Patch({
		url: `${api.setmeal.versionsAudit}/${param.id}`,
	});
};

let activeFeatureList = function () {
	return Get({
		url: api.setmeal.activeFeatureList,
	});
};
let setRenew = function (param,bodyParam) {
	return Patch({
		url: api.setmeal.setRenew,
		PathParam: param,
		bodyParam: bodyParam,
	});
};

function featureDetail(param) {
	return Get({
		url: `${api.setmeal.featureDetail}/${param}`,
	});
}
function featureUpdate(param) {
	return Patch({
		url: `${api.setmeal.featureUpdate}/${param.id}`,
		bodyParam: param,
	});
}
function featureEnabled(param) {
	return Patch({
		url: api.setmeal.featureEnabled,
		PathParam: param,
	});
}

function businessLine(param) {
	return Get({
		url: `${api.setmeal.businessLine}/${param}`,
	});
}

function setMealDetail(param) {
	return Get({
		url: `${api.setmeal.setMealDetail}/${param}`,
	});
}
function setMealUpload(param) {
	return Patch({
		url: `${api.setmeal.setMealUpload}/${param.id}`,
		bodyParam: param,
	});
}

function setMealHistoryLists(param) {
	return Post({
		url: api.setmeal.setMealHistoryLists,
		PathParam: param,
	});
}

function setMealFunctionItemLists(param) {
	return Post({
		url: api.setmeal.setMealFunctionItemLists,
		PathParam: param,
	});
}


function enabledWechatPremission(id) {
	return Patch({
		url: api.setmeal.enabledWechatPremission,
		PathParam: id,
	});
}

function areRenewalsAllowed(id) {
	return Patch({
		url: api.setmeal.areRenewalsAllowed,
		PathParam: id,
	});
}

function setmealEnabled(id) {
	return Patch({
		url: api.setmeal.setmealEnabled,
		PathParam: id,
	});
}

// 获取套餐类型下拉列表;
function getPackageTypeList() {
	return Get({
		url: api.setmeal.getPackageTypeList,
	});
}

function releaseGrayscaleVersion(id, params) {
	return Put({
		url: api.setmeal.releaseGrayscaleVersion,
		PathParam: id,
		UrlParam: params,
	});
}
function redactGrayscaleList(params) {
	return Get({
		url: api.setmeal.redactGrayscaleList,
		PathParam: params,
	});
}
function addGrayscale(params) {
	return Post({
		url: api.setmeal.addGrayscale,
		bodyParam: params,
	});
}
function deleteGrayscale(params) {
	return Put({
		url: api.setmeal.deleteGrayscale,
		PathParam: params,
	});
}
function queryMenuPermission(param) {
	return Get({
		url: api.setmeal.queryMenuPermission,
		PathParam: param,
	});
}
function editRole(params) {
	return Post({
		url: api.setmeal.editRole,
		bodyParam: params,
	});
}
function updateGrayscaleName(params) {
	return Put({
		url: api.setmeal.updateGrayscaleName,
		UrlParam: params,
	});
}

// 自动优惠券
// 新建
function addCoupons(params) {
	return Post({
		url: api.setmeal.addCoupons,
		bodyParam: params,
	});
}

// 详情
function couponsDetails(params) {
	return Get({
		url: api.setmeal.couponsDetails,
		PathParam: params,
	});
}

// 编辑
function editCoupons(id, params) {
	return Patch({
		url: api.setmeal.editCoupons,
		bodyParam: params,
		PathParam: {
			id,
		},
	});
}

// 是否启用
function couponsIsEnabled(params) {
	return Patch({
		url: api.setmeal.couponsIsEnabled,
		PathParam: params,
	});
}

// 套餐选择
function couponsPackagesChoose() {
	return Get({
		url: api.setmeal.couponsPackagesChoose,
	});
}

// 功能下拉列表
function featureDropDownList() {
	return Get({
		url: api.setmeal.featureDropDownList,
	});
}

// 白名单
//是否允许新单
function allowNewOrder(params) {
	return Patch({
		url: api.setmeal.allowNewOrder,
		PathParam: params,
	});
}

// 是否允许续费白名单
function allowRenewWhiteList(params) {
	return Patch({
		url: api.setmeal.allowRenewWhiteList,
		PathParam: params,
	});
}

// 多服务单效验列表
function manyServiceList(params) {
	return Post({
		url: api.setmeal.manyServiceList,
		bodyParam: params,
	});
}

// 续费白名单-新增
function addRenewWhiteList(params) {
	return Post({
		url: api.setmeal.addRenewWhiteList,
		bodyParam: params,
	});
}

// 续费白名单-删除
function deleteRenewWhiteList(params) {
	return Delete({
		url: api.setmeal.deleteRenewWhiteList,
		PathParam: params,
	});
}

// 续费白名单-更新
function editRenewWhiteList(params) {
	return Patch({
		url: api.setmeal.editRenewWhiteList,
		PathParam: params,
		bodyParam: params,
	});
}

// 续费白名单-批量删除
function batchDeleteRenewWhiteList(params) {
	return Post({
		url: api.setmeal.batchDeleteRenewWhiteList,
		bodyParam: params,
	});
} 
//  挂靠权限列表
function affiliatedPermissionsList () {
	return Get({
		url: api.setmeal.affiliatedPermissionsList,
	});
}
//  功能类型列表
function functionItemsTypeList () {
	return Get({
		url: api.setmeal.functionItemsTypeList,
	});
}

export default {
	getserveList,
	versionsAudit,
	activeFeatureList,
	setRenew,
	featureDetail,
	featureUpdate,
	featureEnabled,
	businessLine,
	setMealDetail,
  setMealHistoryLists,
  setMealFunctionItemLists,
	setMealUpload,
	enabledWechatPremission,
	areRenewalsAllowed,
	setmealEnabled,
  getPackageTypeList,
	releaseGrayscaleVersion,
	redactGrayscaleList,
	addGrayscale,
	deleteGrayscale,
	queryMenuPermission,
	editRole,
	updateGrayscaleName,
	addCoupons,
	couponsDetails,
	editCoupons,
	couponsIsEnabled,
	couponsPackagesChoose,
	featureDropDownList,
	allowNewOrder,
	allowRenewWhiteList,
	manyServiceList,
	addRenewWhiteList,
	deleteRenewWhiteList,
	editRenewWhiteList,
	batchDeleteRenewWhiteList,
	affiliatedPermissionsList,
	functionItemsTypeList
};
